// extracted by mini-css-extract-plugin
export default {"wrap":"bA-z","fullWidth":"cA-z","searchPlacement":"dA-z","items":"eA-z","featureCss":"fA-z","disabled":"gA-z","imgCss":"hA-z"};